import { Button } from "@/components/atoms/Buttons/Button";
import { useEscape } from "@/hooks/useKeyboardShortcut";
import { useOutsideClick } from "@/hooks/useOutsideClick";

import ActionModal from "../ActionModal";

type Props = { onDismiss: () => void };

export const SignUpFormMobileClubImportModal = ({ onDismiss }: Props) => {
  const ref = useOutsideClick(() => onDismiss());
  useEscape(() => onDismiss());

  return (
    <ActionModal onDismiss={onDismiss} title="Club Import" size="small">
      <div ref={ref} className="flex flex-col justify-between text-sm">
        <span className="mt-8 mb-4 text-new-gray-600">
          Hi there from the EasySBC Team! <br /> <br /> Club import isn't
          normally available on mobile, but we're currently testing a mobile
          compatible version through our Beta Tester program. <br /> <br />
          If you'd like early access and want to help us improve this feature,
          send us an email at{" "}
          <a
            href="mailto:developer@easysbc.io"
            className="text-blue-500 underline"
          >
            developer@easysbc.io
          </a>
        </span>
        <div className="mx-auto">
          <Button variant="primary" size="medium" onClick={onDismiss}>
            OK
          </Button>
        </div>
      </div>
    </ActionModal>
  );
};
